import { createContext } from 'react';
import { IUser } from 'models/auth';
import { DEFAULT_SETTINGS, Settings } from '@/models/settings';

export const defaultUser: IUser = {
  id: '',
  email: '',
  firstName: '',
  lastName: '',
  role: '',
  token: '',
};

export const UserContext = createContext<{
  user: IUser | null;
  setUser: (user: IUser | null) => void;
}>({
  user: null,
  setUser: () => {},
});

export const ProfileContext = createContext<{
  selectedProfile: IUser;
  setSelectedProfile: (user: IUser) => void;
}>({
  selectedProfile: defaultUser,
  setSelectedProfile: () => {},
});

export const SettingsContext = createContext<{
  settings: Settings;
  setSettings: (partial: Partial<Settings>) => void;
  isLoading: boolean;
}>({
  settings: DEFAULT_SETTINGS,
  setSettings: () => {},
  isLoading: false,
});

export const ThemeContext = createContext<{
  darkTheme: boolean;
  setDarkTheme: (value: boolean) => void;
}>({
  darkTheme: true,
  setDarkTheme: () => {},
});

export const WindowContext = createContext<{
  targetWindow: Window;
}>({
  targetWindow: window,
});

export const PageLoadingContext = createContext<{
  isPageLoading: boolean;
  setPageLoading: (loading: boolean) => void;
}>({
  isPageLoading: false,
  setPageLoading: () => {},
});
